import type { ReactNode } from 'react';
import { Sparkles } from 'lucide-react';

export function AuthShell({ title, subtitle, children, footer }: { title: string; subtitle?: ReactNode; children: ReactNode; footer?: ReactNode }) {
  return (
    <div className="flex min-h-full items-center justify-center bg-bg-sunken p-4">
      <div className="w-full max-w-sm rounded-xl border border-line bg-bg-elev p-6 shadow-sm">
        <div className="mb-5 flex items-center gap-2 text-accent">
          <Sparkles size={20} />
          <span className="text-lg font-semibold tracking-tight text-fg">Lumen</span>
        </div>
        <h1 className="text-xl font-semibold">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-fg-muted">{subtitle}</p>}
        <div className="mt-5">{children}</div>
        {footer && <div className="mt-5 text-sm text-fg-muted">{footer}</div>}
      </div>
    </div>
  );
}
